import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'

import { Rows } from '@/components/layout'
import { Link } from '@/components/common'

import styles from './BlogArticleListingWide.module.scss'

const BlogArticleListingWide = ({ title, link, img, imgAlt, date, details, categories = [] }) => (
  <Rows>
    <div className={styles.imageSection}>
      <div>
        <Link to={link}>
          <Image
            alt={imgAlt}
            height={500}
            src={img}
            style={{ width: '100%', height: 'auto' }}
            width={500}
          />
        </Link>
      </div>
      <div>
        <Rows className={styles.content}>
          <Link className={styles.name} to={link}>{title}</Link>
          <div className={styles.details} dangerouslySetInnerHTML={{ __html: details }} />
        </Rows>
      </div>
    </div>

    <div className={styles.navigation}>
      <div>
        <p className={styles.date}>{date} |&nbsp;
          {categories.map((category, index) => (
            <Fragment key={category.slug}>
              <Link className={styles.categories} to={category.link}>
                {category.name}
              </Link>
              {index < categories.length - 1 && ', '}
            </Fragment>
          ))}
        </p>
      </div>
      <div className={styles.learnMoreHolder}>
        <Link
          className={styles.learnMore}
          messageId="pages.blog.readMore"
          to={link}
        />
      </div>
    </div>
  </Rows>
)

BlogArticleListingWide.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  img: PropTypes.string,
  imgAlt: PropTypes.string,
  date: PropTypes.string,
  details: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.shape({})),
}

export default BlogArticleListingWide
